// extracted by mini-css-extract-plugin
export default {"button":"IconButton-button-t4C5V Link-link-RInnp","isDisabled":"IconButton-isDisabled-qx70J"};